import type { NewOption, Option } from './types';

export const isOption = <Value>(value: unknown | null | undefined): value is Option<Value> =>
  (value as Record<string, unknown>)?.label != null;

export const isNewOption = <ValueType>(
  value: unknown | null | undefined,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
): value is NewOption<ValueType> => isOption(value) && value.__isNew__;

export const isRecord = (value: unknown | null | undefined): value is Record<string, unknown> =>
  typeof value === 'object' && !Array.isArray(value) && value !== null;

export const isStringArray = (value: unknown): value is string[] => Array.isArray(value) && value.every((item) => typeof item === 'string');

export const isValueFromEnum = <T extends string>(value: unknown, enumObject: Record<string, T>): value is T =>
  Object.values(enumObject).includes(value as T);
